export default [ "Read", "Create", "Update", "Delete" ];